import React, { useState } from 'react';
import { Button, HStack } from "native-base";
import SimpleInput from './SimpleInput';
import AppText from './AppText';
import { Colors } from '../../styles/Colors';
import { GlobalStyleAttributes } from '../../styles/GlobalStyles';
import { Flex, Tooltip } from 'antd';
import usePermissions from '../../services/Permissions';
import { isRTL, t } from '../../services/i18n';
import {isMobile, openLimitedPackageModal} from '../../services/Helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {GlobalConsts} from "../../styles/GlobalConsts";
import {useDispatch} from "react-redux";
import EmojiPicker from "./EmojiPicker";



const MessageTextArea = ({tags, onTagClick, setFieldValue, values, maxLength, touched, errors, name, placeholder, id, disabled}) => {
    const {has, hasLock} = usePermissions();
    const dispatch = useDispatch()
    const onEmojiClick = (x) => {
        if (disabled) return
        setFieldValue(name, (values[name] || '') + x.native)
    }

    return <>
    <Flex vertical>
        <HStack borderColor={Colors.borderColor} flexWrap={'wrap'} borderWidth={1} p={'0.3rem'} space={'0.3rem'} borderRadius={'4px 4px 0 0'} top={'1px'} alignItems={'center'} style={{rowGap: '0.3rem', opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : undefined}}>
            <AppText variant={GlobalStyleAttributes.textVariants.heading4}>{`${t('tags')}:`}</AppText>
            {tags.map(tag => {
                const tagButton = tag.id === 'space' ? has('editSpace') &&
                    (<Button
                        bgColor={Colors.newDesign.menuBar}
                        borderColor={Colors.newDesign.menuBar}
                        onPress={() => onTagClick(tag.label)}
                        key={tag.id}
                        width={'auto'}
                        // mb={'0.3rem'}
                        size={'md'} h={8}>
                        <AppText variant={GlobalStyleAttributes.textVariants.heading4}>{tag.label}</AppText>
                    </Button>) :
                    (tag.permission && has(tag.permission) || !tag.permission) && (<Button
                        bgColor={Colors.newDesign.menuBar}
                        style={{opacity: hasLock(tag.permission) && '50%'}}
                        borderColor={(touched[name] && errors[name] && tag.isError) ? Colors.newDesign.attendanceAbsentText : Colors.newDesign.menuBar}
                        borderWidth={1}
                        onPress={hasLock(tag.permission) ? () => openLimitedPackageModal(dispatch) : () => onTagClick(tag.label)}
                        key={tag.id}
                        width={'auto'}
                        size={'md'} h={8}>
                    <HStack alignItems={'center'} space={'0.5rem'}>
                        <AppText variant={GlobalStyleAttributes.textVariants.heading4}>{tag.label}</AppText>
                        {hasLock(tag.permission) && <FontAwesomeIcon icon={'fa-light fa-lock-keyhole'} fontSize={GlobalConsts.iconSize.XS}/>}
                    </HStack>
                    </Button>);
                if (!tag.tooltip || !tagButton) return tagButton
                return <Tooltip title={tag.tooltip} placement={GlobalConsts.menu.placement.TOP} key={tag.id}><span>{tagButton}</span></Tooltip>
            })}
        </HStack>
        <SimpleInput inputType={'multiline'}
            rows={6}
            id={id}
            maxLength={maxLength}
            placeholder={placeholder}
            value={values[name]}
            onChangeCallback={(val) => setFieldValue(name, val)}
            status={touched[name] && errors[name] ? 'error' : null}
            styleOverride={{borderRadius: '0 0 4px 4px'}}
            disabled={disabled}
        />
        {!isMobile && !disabled && <div style={{position: 'absolute', [isRTL() ? 'left' : 'right']: '10px', bottom: '10px'}}>
            <EmojiPicker onEmojiClick={onEmojiClick}/>
        </div>}
    </Flex>
    </>
}
export default MessageTextArea;